"use client";

import type { PropertyLink } from "@/utils/footer-links";
import { distributeLinksAcrossColumns } from "@/utils/footer-links";
import { type ReactNode } from "react";
import { FooterClient } from "./client";

// Fallback static links with proper URLs
const fallbackQuickLinks: PropertyLink[] = [
	{ label: "Apartment In BTM Layout", href: "/bengaluru/apartments-in-btm-layout" },
	{ label: "Apartment In Banashankari", href: "/bengaluru/apartments-in-banashankari" },
	{ label: "Apartment In Bellandur", href: "/bengaluru/apartments-in-bellandur" },
	{ label: "Apartment In Electronic City", href: "/bengaluru/apartments-in-electronic-city" },
	{ label: "Apartment In Horamavu", href: "/bengaluru/apartments-in-horamavu" },
	{ label: "Apartment In HSR Layout", href: "/bengaluru/apartments-in-hsr-layout" },
	{ label: "Apartment In JP Nagar", href: "/bengaluru/apartments-in-jp-nagar" },
	{ label: "Apartment In K R Puram", href: "/bengaluru/apartments-in-k-r-puram" },
	{ label: "Apartment In Kalyan Nagar", href: "/bengaluru/apartments-in-kalyan-nagar" },
	{ label: "Apartment In Whitefield", href: "/bengaluru/apartments-in-whitefield" },
];

interface FooterHybridProps {
	// Pre-fetched data from server (for SSR)
	initialLinkColumns?: PropertyLink[][];
	seoContent?: ReactNode;
}

export function FooterHybrid({ initialLinkColumns, seoContent }: FooterHybridProps) {
	// Use server-provided data or fallback links - no client-side fetching to prevent flashing
	const linkColumns = initialLinkColumns || distributeLinksAcrossColumns(fallbackQuickLinks, 4);

	return <FooterClient linkColumns={linkColumns} seoContent={seoContent} />;
}
